import { NetworkStatus } from "@apollo/client";

import { PollingIntervalGroups } from "apollo/constants";
import usePolledQuery from "apollo/usePolledQuery";

import { GET_OPEN_TOFU_MIGRATION_COUNTS } from "./gql";

const useOpenTofuMigrationCounts = (pollingGroup: PollingIntervalGroups) => {
  const { loading, data, error, refetch, networkStatus } = usePolledQuery(
    GET_OPEN_TOFU_MIGRATION_COUNTS,
    { pollingGroup }
  );

  const counts = data?.openTofuMigrationCounts;
  const isLoading = (loading && !counts) || networkStatus === NetworkStatus.refetch;

  const eligibleToMigrate = counts?.eligibleToMigrate ?? 0;
  const queuedToMigrate = counts?.queuedToMigrate ?? 0;
  const queuedToRollback = counts?.queuedToRollback ?? 0;
  const migrated = counts?.migrated ?? 0;
  const rolledBack = counts?.rolledBack ?? 0;
  const failed = counts?.failed ?? 0;

  return {
    eligibleToMigrate,
    queuedToMigrate,
    queueEntries: queuedToMigrate + queuedToRollback + migrated + rolledBack + failed,
    pendingEntries: queuedToMigrate + queuedToRollback,
    isLoading,
    error,
    refetch,
  };
};

export default useOpenTofuMigrationCounts;
